module.exports = __webpack_public_path__ + "img/20220112_121459.d585a310.jpg";